const SENSITIVE_COOKIE_SUFFIXES = ['-access', '-refresh'];

export interface ExtendedSentryEvent extends ErrorEvent {
  sdkProcessingMetadata?: {
    request?: {
      cookies?: Record<string, string>;
    };
  };
}

function isSensitiveCookie(key: string): boolean {
  return SENSITIVE_COOKIE_SUFFIXES.some((suffix) => key.toLowerCase().endsWith(suffix));
}

export function anonymizeAccessCookies(cookies: Record<string, string>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(cookies).map(([key, value]) => {
      if (isSensitiveCookie(key) || key.toLowerCase() === 'selectedInstitution') {
        return [key, '[anonymized_token]'];
      }
      return [key, value];
    })
  );
}

export function anonymizeCookieHeader(header: string): string {
  return header
    .split(';')
    .map((cookie) => {
      const [key, value] = cookie.trim().split('=');
      if (isSensitiveCookie(key) || key.toLowerCase() === 'selectedInstitution') {
        return `${key}=[anonymized_token]`;
      }
      return `${key}=${value}`;
    })
    .join('; ');
}